<nav class="account-side-menu" *ngIf="!isLoading">
  <div class="asm-profile">
    <div
      class="asm-avatar"
      (click)="fileInput.click()"
      title="Upload photo"
    >
      <img
        *ngIf="imagePreviewUrl == null"
        [ngSrc]="profilePicture || 'assets/images/no_avatar.png'"
        width="112"
        height="112"
      />
      <img
        *ngIf="imagePreviewUrl != null"
        [ngSrc]="imagePreviewUrl"
        width="112"
        height="112"
      />
      <span class="asm-avatar-overlay">
        <i class="material-icons">photo_camera</i>
      </span>
    </div>

    <span class="d-none">
      <input
        type="file"
        #fileInput
        name="file"
        ng2FileSelect
        [uploader]="imageUploader"
        (click)="
          image = null; imagePreviewUrl = null; imageUploader.clearQueue()
        "
        accept="image/*"
      />
    </span>

    <p class="asm-name">{{ settingsData?.name }}</p>
    <p class="asm-org">{{ settingsData?.organization.name }}</p>

    <button
      class="btn btn-primary btn-sm mt-2"
      *ngIf="imageNeedsUpdate"
      [disabled]="imagePreviewUrl == null"
      (click)="updateProfilePicture(); imageNeedsUpdate = false"
    >
      Save photo
    </button>
  </div>

  <div class="asm-stats">
    <div class="asm-stat">
      <span class="asm-stat-value">{{ counts?.athleteCount }}</span>
      <span class="asm-stat-label">{{ _pt('athletes_title').toLowerCase() }}</span>
    </div>
    <div class="asm-stat">
      <span class="asm-stat-value">{{ counts?.exerciseCount }}</span>
      <span class="asm-stat-label">exercises</span>
    </div>
  </div>

  <p class="asm-section-title">Account</p>

  <button class="asm-item" (click)="openAccountInformationModal()">
    <i class="material-icons">badge</i>
    <span>Change account information</span>
    <i class="material-icons asm-chevron">chevron_right</i>
  </button>

  <button class="asm-item" (click)="openPasswordModal()">
    <i class="material-icons">lock</i>
    <span>Change password</span>
    <i class="material-icons asm-chevron">chevron_right</i>
  </button>

  <p class="asm-section-title">Reports</p>

  <button class="asm-item" (click)="openLogsModal()">
    <i class="material-icons">description</i>
    <span>Generate logs report</span>
    <i class="material-icons asm-chevron">chevron_right</i>
  </button>

  <button class="asm-item" (click)="openUsageModal()">
    <i class="material-icons">insights</i>
    <span>Generate usage reports</span>
    <i class="material-icons asm-chevron">chevron_right</i>
  </button>

  <button
    class="asm-item"
    (click)="exportOrganizationUsageReport()"
    *ngIf="isSuperAdmin()"
  >
    <i class="material-icons">corporate_fare</i>
    <span>Export organization usage report</span>
    <i class="material-icons asm-chevron">chevron_right</i>
  </button>

  <p class="asm-section-title">Data sync</p>

  <div class="asm-field">
    <app-sync-button (syncStateChanged)="onSyncStateChanged($event)">
    </app-sync-button>
  </div>

  <button class="asm-item" *ngIf="showQuickbooks" (click)="connectQuickbooks()">
    <i class="material-icons">sync_alt</i>
    <span>Connect Quickbooks</span>
    <i class="material-icons asm-chevron">chevron_right</i>
  </button>

  <p class="asm-section-title">Subscription</p>

  <div class="asm-plan">
    <span class="asm-plan-label">Current plan</span>
    <span class="asm-plan-name">{{ settingsData?.subscription.name }}</span>
  </div>

  <button class="asm-item" (click)="openSubscriptionPaymentModal()">
    <i class="material-icons">credit_card</i>
    <span>Update payment info</span>
    <i class="material-icons asm-chevron">chevron_right</i>
  </button>

  <div class="asm-item asm-item--static">
    <i class="material-icons">mark_email_read</i>
    <span>Enforce mandatory email</span>
    <mat-slide-toggle
      (change)="updateMandatoryEmail()"
      [(ngModel)]="mandatoryEmail"
    >
    </mat-slide-toggle>
  </div>

  <p class="asm-section-title">Legal</p>

  <div class="asm-item asm-item--static">
    <i class="material-icons">gavel</i>
    <a routerLink="/terms-and-conditions">Terms and Conditions</a>
    <a
      href="/assets/pdf/Quick%20Board%20Terms.pdf"
      class="asm-chevron"
      title="Download Terms and Conditions"
      ><i class="material-icons">cloud_download</i></a
    >
  </div>

  <div class="asm-item asm-item--static">
    <i class="material-icons">privacy_tip</i>
    <a routerLink="/privacy-policy">Privacy Policy</a>
    <a
      href="/assets/pdf/Quick%20Board%20Privacy%20Policy.pdf"
      class="asm-chevron"
      title="Download Privacy Policy"
      ><i class="material-icons">cloud_download</i></a
    >
  </div>
</nav>

<div
  class="flex justify-center items-center w-full h-[400px]"
  *ngIf="isLoading"
>
  <mat-spinner diameter="50"></mat-spinner>
</div>
